import { component } from "picoapp";
import { addVariant } from "base/scripts/utils/cart.js";
import { qs, qsa, has, on } from "martha";
import choozy from "choozy";

export default component((node, ctx) => {
  let { subDetailToggle, subDetail } = choozy(node);

  const products = qsa(".js-product", node);
  const addBtn = qs(".js-add-bundle", node);

  if (addBtn) {
    on(addBtn, "click", async (e) => {
      e.preventDefault();

      let bundle = qsa(".js-product", node);

      try {
        // Add all add-ons first
        for (let el of bundle) {
            
          const json = JSON.parse(
            qs(`.js-product-json`, el).innerHTML
          );

          const { selectedOrFirstAvailableVariant, product } = json
          console.log('json', json);

          let selectedVariant = qs('select[name="id"]', el).value

          let currentVariant = selectedVariant
            ? product.variants.filter(
                (v) => v.id === parseInt(qs('select[name="id"]', el).value)
              )[0]
            : currentVariant

            console.log('currentVariant', currentVariant);
            
          



        // addonVariant = product?.variants?.filter(
        //     (v) =>
        //       v.id ===
        //     parseInt(qs('select[name="id"]', el).value)
        //   )[0];

          if (currentVariant) {
            await addVariant(currentVariant, 1, false); // Await the add-on addition
          }
        }
      } catch (error) {
        console.error('Error adding products:', error);
      }
    });
  }

  return () => {};
});
